// shared-lib/kitchen-assembly/intentRules.js
//
// The rules the kitchen layout GENERATOR states as links when a candidate
// takes a decision (reference-docs/layout-relationships §3.4). The `rule` tag
// says WHICH decision a link records; it is read by the group editor's
// `describeLink` and by the corpus contract test.
//
// It is deliberately NOT read when a layout is applied. That used to ask
// "did the generator write this link?" and keep the ones that answered no;
// a layout apply now replaces the room's links wholesale, whoever wrote them
// (`nextRoomLinksForLayout`).

const SINK_ON_WINDOW = 'sinkOnWindow';
const ENDPOINT_SNAP = 'endpointSnap';

module.exports = {
  SINK_ON_WINDOW,
  ENDPOINT_SNAP,
};
